import { styled } from "@mui/material";

export const RideNotAvailableText = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh"
});
